import React from 'react'
import { Container } from '@mui/material'

function AppContainer({children}) {
    return (
        <Container maxWidth='md' disableGutters>
            {children}
        </Container>
    )
}

export default AppContainer